export function tabScroll() {
  function mousedragscrollable(element) {
    let target;
    element.forEach((e) => {
      e.addEventListener('mousedown', function (event) {
        event.preventDefault();
        target = e;
        target.dataset.down = true;
        target.dataset.move = false;
        target.dataset.x = event.clientX;
        target.dataset.y = event.clientY;
        target.dataset.scrollleft = e.scrollLeft;
        target.dataset.scrolltop = e.scrollTop;
        return false;
      });

      e.addEventListener('click', function (event) {
        if (target && target.dataset.move === "true") {
          event.preventDefault();
          return false;
        }
      });
    });

    document.addEventListener('mousemove', function (event) {
      if (target && target.dataset.down === "true") {
        event.preventDefault();
        let move_x = target.dataset.x - event.clientX;
        let move_y = target.dataset.y - event.clientY;
        if (move_x !== 0 || move_y !== 0) {
          target.dataset.move = true;
        } else {
          target.dataset.move = false;
          return;
        }
        target.scrollLeft = parseInt(target.dataset.scrollleft) + move_x;
        target.scrollTop = parseInt(target.dataset.scrolltop) + move_y;
        return false;
      }
    });

    document.addEventListener('mouseup', function () {
      if (target) {
        target.dataset.down = false;
      }
      return false;
    });
  }

  const scrollElements = document.querySelectorAll('.scroll');
  mousedragscrollable(scrollElements);
}